/* eslint-disable no-extend-native */
String.prototype.replaceAll = function(find, replace) {
    return this.replace(new RegExp(find.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&'), 'g'), replace);
};

String.prototype.commafy = function(){
	return this.replace(/(^|[^\w.])(\d{4,})/g, function($0, $1, $2) {
		return $1 + $2.replace(/\d(?=(?:\d\d\d)+(?!\d))/g, "$& ");
	});
};

Number.prototype.commafy = function(){
	return this.toString().replace(/(^|[^\w.])(\d{4,})/g, function($0, $1, $2) {
		return $1 + $2.replace(/\d(?=(?:\d\d\d)+(?!\d))/g, "$& ");
	});
};

Number.prototype.between = function(a, b) {
  var 	min = Math.min.apply(Math, [a, b]),
		max = Math.max.apply(Math, [a, b]);
  return this >= min && this <= max;
};

String.prototype.xmoney = function(n){
	return ((n === true) ? Number(this.replace(' ', '').replace('€','')) : this.commafy()+' €');
};

Number.prototype.xmoney = function(n){
	return ((n === true) ? this : this.commafy()+' €');
};

Number.prototype.round = function(decimals){
	return Number((Math.round(this * 100) / 100).toFixed(decimals));
};

Number.prototype.discount = function(percents){
	return this * (percents / 100);
};

Number.prototype.toHHMMSS = function() {
    var hours = Math.floor(this / 3600) < 10 ? ("00" + Math.floor(this / 3600)).slice(-2) : Math.floor(this / 3600);
    var minutes = ("00" + Math.floor((this % 3600) / 60)).slice(-2);
    var seconds = ("00" + (this % 3600) % 60).slice(-2);
    return hours + ":" + minutes + ":" + seconds;
};

String.prototype.discount = function(percents){
	return Number(this) * (percents / 100);
};

String.prototype.format = function(){
	for (var s = String(this), i = 0, len = arguments.length; i < len; i++){
		s = s.replace(new RegExp("\\[" + i + "\\]", "gm"), (arguments[i] || ''));
		s = s.replace(new RegExp("\\{" + i + "\\}", "gm"), (arguments[i] || '')); //del jquery steps xbug
	}
	return s;
};

String.prototype.formatProc = function(obj){
	var keys = Object.keys(obj),
		val;
	for (var s = String(this), i = 0, len = keys.length; i < len; i++){
		val =  obj[keys[i]];
		if (!val){
			s = s.replace('@'+keys[i], 'null');
		} else {
			s = s.replace('@'+keys[i], obj[keys[i]]);
		}
	}

	return s;
};

/** Pakeičia ąčęėįšųūž - aceeisuuz */ 
String.prototype.translate_lt = function(){
	var lt_map = {
		'ą': 'a',
		'č': 'c',
		'ę': 'e',
		'ė': 'e',
		'į': 'i',
		'š': 's',
		'ų': 'u',
		'ū': 'u',
		'ž': 'z',
		'Ą': 'A',
		'Č': 'C',
		'Ę': 'E',
		'Ė': 'E',
		'Į': 'I',
		'Š': 'S',
		'Ų': 'U',
		'Ū': 'U',
		'Ž': 'Z'
	};

	return this.replace(/[^a-zA-Z]/g, function (l) { 
		return lt_map[l] || l; 
	});
};

String.prototype.formatData = function(){
	var template = String(this),
		data = arguments[0],
		isArray = Array.isArray(data[0]),
		temp,
		html = '';
	if (!data || data.length === 0){
		return;
	}

	//masyvu masyvas
	if (isArray){
		$.each(data, function(index, value){
			html += String.prototype.format.apply(template,value);
		});

		return html;
	}
	//objektu masyvas
	if (typeof data[0] === 'object'){
		$.each(data, function(index, value){
			temp = template;
			for (var k in value){
				//log(k +' => '+ value[k]);
				temp = temp.replaceAll('['+k+']', (value[k]) ? value[k] : '');
			}
			html += temp;
		});

		return html;
	}
	// objektas
	if (typeof data === 'object' && Array.isArray(data) === false){
		for (var k in data){
			template = template.replaceAll('['+k+']', (data[k]) ? data[k] : '');
		}
		return template;
	}
	//masyvas
	return String.prototype.format.apply(template, data);
};

Array.prototype.groupby = function(key) {
	return this.reduce(function(rv, x) {
		(rv[x[key]] = rv[x[key]] || []).push(x);
		return rv;
	},[]).filter(function(val){ return val});
};
/** ISTRINA TUSCIUS ELEMENTUS, arba tam tikrus
* @param {deleteValue} - kokia reiksme trinti, jei nepaduota tada ''
* returns object
*/
Array.prototype.clean = function(deleteValue) {
	if (!deleteValue){
		deleteValue = '';
	}
	for (var i = 0; i < this.length; i++) {
		if (this[i] == deleteValue) {         
		  this.splice(i, 1);
		  i--;
		}
	}
	return this;
};
/* viskas luzta, paziureti kodel
Object.prototype.length = function(){
	return Object.keys(this).length;
};
*/